import { createRouter, createWebHistory } from "vue-router";
import Layout from "@/layout/Layout.vue";
import Main from "@/components/Main.vue";
import userManage from "@/user/userManage.vue";
import noticeManage from "@/notice/notice.vue";
import standard from "@/standard/standard.vue";
import notice from "@/notice/notice.vue";
import MainFrame from "@/components/MainFrame.vue";
import Content from "@/content/Content.vue";
import { useMenuStore } from "@/stores/menu";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/Login.vue"),
      meta: { requiresAuth: false },
    },
    {
      path: "/",
      component: Layout,
      redirect: "/standard",
      children: [
        {
          path: "mainFrame",
          name: "mainFrame",
          component: MainFrame,
          meta: { requiresAuth: true },
        },
        {
          path: "caidan",
          name: "caidan",
          component: Main,
          meta: { requiresAuth: true },
        },
        {
          path: "noticeManage",
          name: "noticeManage",
          component: noticeManage,
          meta: { requiresAuth: true },
        },
        {
          path: "userManage",
          name: "userManage",
          component: userManage,
          meta: { requiresAuth: true },
        },
        {
          path: "standard",
          name: "standard",
          component: standard,
          meta: { requiresAuth: true },
        },
        {
          path: "notice",
          name: "notice",
          component: notice,
          meta: { requiresAuth: true },
        },
        {
          path: "content",
          name: "content",
          component: Content, // 确保路径正确
          meta: { requiresAuth: true },
        },
      ],
    },
  ],
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // 检查URL参数中是否有token
  const urlParams = new URLSearchParams(window.location.search);
  const urlToken = urlParams.get('token');
  
  // 如果URL中有token，则存储到localStorage
  if (urlToken) {
    localStorage.setItem('token', urlToken);
    // 清除URL中的token参数，避免暴露在地址栏
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete('token');
    window.history.replaceState({}, '', newUrl.toString());
  }
  
  const token = localStorage.getItem("token");
  
  if (to.meta.requiresAuth && !token) {
    next("/login");
  } else if (to.path === "/login" && token) {
    next("/standard");
  } else if (to.meta.requiresStore) {
    const store = useMenuStore();
  } else {
    next();
  }
});

export default router;
